import { 
    CHANGE_PCT_NOTIFIER,
    CHANGE_SENT_PCT_RESULT,
    DOWNLOAD_MULTIPLE_PCT_EXCEL,
    DOWNLOAD_MULTIPLE_PCT_EXCEL_SUCCESS,
    DOWNLOAD_MULTIPLE_PCT_PDF,
    DOWNLOAD_MULTIPLE_PCT_PDF_SUCCESS,
    DOWNLOAD_PCT_EXCEL,
    DOWNLOAD_PCT_EXCEL_SUCCESS,
    DOWNLOAD_PCT_PDF,
    DOWNLOAD_PCT_PDF_SUCCESS,
    GET_PCT_INFO,
    GET_PCT_INFO_LIST,
    GET_PCT_INFO_LIST_SUCCESS,
    GET_PCT_INFO_LIST_SUCCESS_UNLOCK,
    GET_PCT_INFO_SUCCESS,
    GET_PCT_NOTIFIER_SETTINGS,
    GET_PCT_NOTIFIER_SETTINGS_SUCCESS,
    HIDE_PCT_TARGET,
    MULTIPLE_HIDE_PCT,
    MULTIPLE_HIDE_PCT_SUCCESS,
    MULTIPLE_STAR_PCT,
    MULTIPLE_STAR_PCT_SUCCESS,
    MULTIPLE_UNHIDE_PCT,
    MULTIPLE_UNHIDE_PCT_SUCCESS,
    MULTIPLE_UNSTAR_PCT,
    MULTIPLE_UNSTAR_PCT_SUCCESS,
    PREVIEW_PCT_EMAIL,
    PREVIEW_PCT_EMAIL_SUCCESS,
    SAVE_PCT_NOTIFIER_SETTINGS,  
    SAVE_PCT_NOTIFIER_SETTINGS_SUCCESS, 
    SEND_PCT_EMAIL, 
    SEND_PCT_EMAIL_SUCCESS, 
    SET_PCT_LOADING,
    SET_PCT_RESULTS,
    SET_PCT_SENT_SUCCESS,
    SET_PCT_SETTINGS,
    SET_PCT_SUCCESS,
    SET_PREVIEW_PCT_EMAIL,
    SET_UPGRADE_ALERT_MESSAGE,
    STAR_PCT_TARGET,
    UNHIDE_PCT_TARGET,
    UNLOCK_PCT,
    UNLOCK_PCT_SUCCESS,
    UNSTAR_PCT_TARGET
} from "./actionTypes"

export const savePctNotifierSettings = (data) =>{
    return {
        type: SAVE_PCT_NOTIFIER_SETTINGS,
        payload: data,
    }
}

export const savePctNotifierSettingsSuccess = (data) =>{
    return {
        type: SAVE_PCT_NOTIFIER_SETTINGS_SUCCESS,
        payload: data,
    }
}

export const getPctNotifierSettings = () => {
    return {
        type: GET_PCT_NOTIFIER_SETTINGS,
    }
}

export const getPctNotifierSettingsSuccess = (data) => {
    return {
        type: GET_PCT_NOTIFIER_SETTINGS_SUCCESS,
        payload: data,
    }
}

export const setPctLoading = (loading) => {
    return {
        type: SET_PCT_LOADING,
        payload: loading,
    }
}

export const setPctSuccess = (success) => {
    return {
        type: SET_PCT_SUCCESS,
        payload: success,
    }
}

export const getPctInfo = (data) => {
    return {
        type: GET_PCT_INFO,
        payload: data,
    }
}

export const getPctInfoSuccess = (data) => {
    return {
        type: GET_PCT_INFO_SUCCESS,
        payload: data,
    }
}

export const multipleStarPct = (data) => {
    return {
        type: MULTIPLE_STAR_PCT,
        payload: data,
    }
}

export const multipleStarPctSuccess = (data) => {
    return {
        type: MULTIPLE_STAR_PCT_SUCCESS,
        payload: data,
    }
}

export const multipleUnstarPct = (data) => {
    return {
        type: MULTIPLE_UNSTAR_PCT,
        payload: data,
    }
}

export const multipleUnstarPctSuccess = (data) => {
    return {
        type: MULTIPLE_UNSTAR_PCT_SUCCESS,
        payload: data,
    }
}

export const multipleHidePct = (data) => {
    return {
        type: MULTIPLE_HIDE_PCT,
        payload: data,
    }
}

export const multipleHidePctSuccess = (data) => {
    return {
        type: MULTIPLE_HIDE_PCT_SUCCESS,
        payload: data,
    }
}

export const multipleUnhidePct = (data) => {
    return {
        type: MULTIPLE_UNHIDE_PCT,
        payload: data,
    }
}
export const multipleUnhidePctSuccess = (data) => {
    return {
        type: MULTIPLE_UNHIDE_PCT_SUCCESS,
        payload: data,
    }
}

export const getPctInfoList = (data) => {
    return {
        type: GET_PCT_INFO_LIST,
        payload: data,
    }
}

export const getPctInfoListSuccess = (data) => {
    return {
        type: GET_PCT_INFO_LIST_SUCCESS,
        payload: data,
    }
}

export const starPctTarget = (targetGroupNo, pctNotifierList) => {
    return {
        type: STAR_PCT_TARGET,
        payload: {targetGroupNo, pctNotifierList},
    }
}

export const unstarPctTarget = (targetGroupNo, pctNotifierList) => {
    return {
        type: UNSTAR_PCT_TARGET,
        payload: {targetGroupNo, pctNotifierList},
    }
}

export const hidePctTarget = (targetGroupNo, pctNotifierList) => {
    return {
        type: HIDE_PCT_TARGET,
        payload: {targetGroupNo, pctNotifierList},
    }
}

export const unhidePctTarget = (targetGroupNo, pctNotifierList) => {
    return {
        type: UNHIDE_PCT_TARGET,
        payload: {targetGroupNo, pctNotifierList},
    }
}

export const changePctNotifier = (data) => {
    return {
        type: CHANGE_PCT_NOTIFIER,
        payload: data,
    }
}

export const setPctResults = (data) => {
    return {
        type: SET_PCT_RESULTS,
        payload: data,
    }
}

export const unlockPct = (data) => {
    return {
        type: UNLOCK_PCT,
        payload: data,
    }
}

export const unlockPctSuccess = (data) => {
    return {
        type: UNLOCK_PCT_SUCCESS,
        payload: data,
    }
}

export const getPctInfoListSuccessUnlock = (data) => {
    return {
        type: GET_PCT_INFO_LIST_SUCCESS_UNLOCK,
        payload: data,
    }
}

export const downPCtExcel = (data, fileName) => {
  return {
    type: DOWNLOAD_PCT_EXCEL,
    payload: {data, fileName},
  };
};

export const downPCtExcelSuccess = (data) => {
  return {
    type: DOWNLOAD_PCT_EXCEL_SUCCESS,
    payload: data,
  };
};

export const downloadMultiplePctExcel = (data, fileName) => {
  return {
    type: DOWNLOAD_MULTIPLE_PCT_EXCEL,
    payload: {data, fileName},
  };
};

export const downloadMultiplePctExcelSuccess = (data) => {
  return {
    type: DOWNLOAD_MULTIPLE_PCT_EXCEL_SUCCESS,
    payload: data,
  };
};

export const downloadPctPdf = (data, fileName) => {
  return {
    type: DOWNLOAD_PCT_PDF,
    payload: {data, fileName},
  };
};

export const downloadPctPdfSuccess = (data) => {
  return {
    type: DOWNLOAD_PCT_PDF_SUCCESS,
    payload: data,
  };
};

export const downloadMultiplePctPdf = (data, fileName) => {
  return {
    type: DOWNLOAD_MULTIPLE_PCT_PDF,
    payload: {data, fileName},
  };
};

export const downloadMultiplePctPdfSuccess = (data) => {
  return {
    type: DOWNLOAD_MULTIPLE_PCT_PDF_SUCCESS,
    payload: data,
  };
};

export const previewPctEmail = (data) => {
    return {
        type: PREVIEW_PCT_EMAIL,
        payload: data,
 };
};

export const previewPctEmailSuccess = (data) => {
    return {
        type: PREVIEW_PCT_EMAIL_SUCCESS,
        payload: data,
    };
};

export const setPreviewPctEmail = (data) => {
    return {
        type: SET_PREVIEW_PCT_EMAIL,
        payload: data,
    };
};

export const sendPctEmail = (data) => {
    return {
        type: SEND_PCT_EMAIL,
        payload: data,
    };
};

export const sendPctEmailSuccess = (data) => {
    return {
        type: SEND_PCT_EMAIL_SUCCESS,
        payload: data,
    };
};

export const changeSentPctResult = (data) => {
    return {
        type: CHANGE_SENT_PCT_RESULT,
        payload: data,
    };
}

export const setPctSentSuccess = (data) => {
    return {
        type: SET_PCT_SENT_SUCCESS,
        payload: data,
    };
};

export const setUpgradeAlertMessage = (data) => {
    return {
        type: SET_UPGRADE_ALERT_MESSAGE,
        payload: data,
    };
};

export const setPctSettings = (data) => {
    return {
        type: SET_PCT_SETTINGS,
        payload: data,
    };
}


